/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Request from '../../utils/request';
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import "./style.less";

function hexColorToRgba(hexColor, opacity) {
  if (!hexColor) {
    return hexColor
  }
  const alphaMaxVal = 1
  hexColor = hexColor.replace("#", "");

  //用于分割16进制色彩通道
  let reg = new RegExp("\\w{1,2}", "g");
  //分割颜色通道
  let rgbaArray255 = hexColor.match(reg);
  rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
    //计算每个通道的10进制值
    let colorVal = parseInt(channel, 16);
    if (index === 3) {
      //这是alpha通道
      return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
    }
    return colorVal;
  });
  return `rgb(${rgbaArray255.join(',')},${opacity})`;
}

class PipelineProductGather extends React.Component {
  constructor(props) {
    super(props);
    const { cardBaseConfig = {} } = props.config;
    const sortType = cardBaseConfig.sortType;
    // 初始化商品id列表数据
    const initList = sortType === '自定义排序' ? props.config.itemList.map(item => {
      return {
        ...item,
        title: item.name,
        url: item.productHref,
        image: item.productImageCustom || 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'
      };
    }) : props.config.itemList.map(item => {
      return {
        image: 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png', // 空白占位图
      };
    });
    this.initList = initList;
    this.state = {
      list: []
    };
    this.sortTypeMap = {
      '自定义排序': 0,
      '销量': 4,
      'GMV': 6,
      '上新时间': 8,
      '热度': 18,
    };
    this.saleTypeMap = {
      '默认': 4,
      '近1天': 10,
      '近7天': 12,
      '近14天': 14,
      '近30天': 16
    }
    this.gatherRef = null;
  }

  componentDidMount() {
    this.getProductListData();
  }

  addEventListenerScroll = () => {
    const goodsScroll = this.goodsScrollRef;
    const progressBg = this.carouselBgRef;
    const progress = this.progressRef;
    if (goodsScroll && progressBg && progress) {
      const goodsScrollWidth = goodsScroll.scrollWidth - goodsScroll.clientWidth;
      const progressWidth = progressBg.clientWidth - progress.clientWidth;
      goodsScroll.addEventListener('scroll', () => {
        if (goodsScroll.scrollLeft >= goodsScrollWidth) {
          this.isScrollEnd = true;
        }
        const progressLeft = (goodsScroll.scrollLeft / goodsScrollWidth) * progressWidth;
        progress.style.left = progressLeft + 'px';
      });
    }
  }

  getProductListData() {
    let itemList = [];
    const { cardBaseConfig = {} } = this.props.config; 
    const { productType, productStyle, sortType, dateRange, shihuoSubsidy, showRectImg } = cardBaseConfig;
    if (sortType === '自定义排序') {
      itemList = JSON.parse(JSON.stringify(this.initList))
    } else {
      itemList = this.props.config.itemList;
    }
    const itemDataObj = {};
    const idList = itemList.map((item) => {
      if (item.id) {
        itemDataObj[item.id] = item;
      }
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    if (productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "配色id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    } else if (productType === "skuId") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";
    }

    let sort_tag = 0;
    if (sortType === '销量') {
      if (!dateRange || dateRange === '默认') {
        sort_tag = 4
      } else {
        sort_tag = this.saleTypeMap[dateRange]
      }
    } else {
      sort_tag = this.sortTypeMap[sortType]
    }
    Request({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: sort_tag,
        filter_subsidy: shihuoSubsidy === '是' ? 1 : 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const { List = [], notFoundList = [] } = res.data.data;
        if (sortType === '自定义排序') {
          itemList.forEach((item, index) => {
            if (item.id == '0') {
              // 无渠道商品，插入列表中
              const element = {
                id: item.id,
                image: item.productImageCustom,
                price: item.productPrice,
                title: item.name,
                url: item.productHref,
                useCustomName: item.useCustomName,
                title: item.name,
                recommendType: item.recommendType,
                shoppersLabel: item.shoppersLabel,
                recommend: item.recommend,
                pocket: '超值好物',
                custom_unitPrice: item.shoppersLabelText,
                image: item.productImageCustom
              }
              List.splice(index, 0, element)
            }
          });
          // 插入定制化内容
          let rectImgs = 0, showRectImg = false;
          itemList.forEach((product) => {
            try {
              const customItem = List.find((item) => item.id == product.id);
              if (sortType === '销量') {
                switch (dateRange) {
                  case '近1天':
                    customItem.sell_point = customItem.realSaleNum;
                    customItem.sell_point_str = String(customItem.realSaleNum);
                    break;
                  case '近7天':
                    customItem.sell_point = customItem.realSaleNum7;
                    customItem.sell_point_str = String(customItem.realSaleNum7);
                    break;
                  case '近14天':
                    customItem.sell_point = customItem.realSaleNum14;
                    customItem.sell_point_str = String(customItem.realSaleNum14);
                    break;
                  case '近30天':
                    customItem.sell_point = customItem.realSaleNum30;
                    customItem.sell_point_str = String(customItem.realSaleNum30);
                    break;
                  default:
                    break;
                }
              }
              if (customItem && customItem.id != '0') {
                // 商品维度，商品图片和价格均要实时获取
                Object.assign(product, {
                  ...customItem,
                  image: productType !== '商品id' ? ((product.image && product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2') < 0) ? product.image : customItem.image) : customItem.image,
                  title: product.useCustomName ? product.name : customItem.title,
                  price: productType !== '商品id' ? (product.productPrice || customItem.price) : customItem.price,
                  recommend: product.recommendType === '自定义' ? (product.recommend) : (customItem.recommend),
                  pocket: '超值好物'
                })
              }
              if (product.rectImg) {
                rectImgs++;
              }
            } catch (error) {
              const customItem_beta = itemDataObj[product.id];
              if (customItem_beta) {
                product.useCustomName = customItem_beta.useCustomName;
                product.title = customItem_beta.name;
                product.recommend = customItem_beta.recommend;
              }
            }
          });
          if (cardBaseConfig.showRectImg === '是' && rectImgs == itemList.length) {
            showRectImg = true;
          }
          if (notFoundList.length > 0) {
            // 删除 notFoundList 中存在的商品
            itemList = itemList.filter(product => {
              const notFound = notFoundList.find(item => item == product.id);
              return notFound ? false : true
            });
          }
          this.setState({
            visiable: true,
            showRectImg: showRectImg,
            list: itemList
          }, () => {
            this.setSalesVisiable();
            this.addEventListenerScroll();
          });
        } else {
          // 非自定义排序，以实时抓取的数据顺序展示
          itemList.forEach((item, index) => {
            if (item.id == '0') {
              // 无渠道商品，插入列表中
              const element = {
                id: item.id,
                image: item.productImageCustom,
                price: item.productPrice,
                title: item.name,
                url: item.productHref,
                useCustomName: item.useCustomName,
                title: item.name,
                recommendType: item.recommendType,
                shoppersLabel: item.shoppersLabel,
                recommend: item.recommend,
                pocket: '超值好物',
                custom_unitPrice: item.shoppersLabelText,
                image: item.productImageCustom
              }
              List.splice(index, 0, element)
            }
          });
          // 插入定制化内容
          let rectImgs = 0, showRectImg = false;
          List.forEach((product) => {
            if (sortType === '销量') {
              switch (dateRange) {
                case '近1天':
                  product.sell_point = product.realSaleNum;
                  product.sell_point_str = String(product.realSaleNum);
                  break;
                case '近7天':
                  product.sell_point = product.realSaleNum7;
                  product.sell_point_str = String(product.realSaleNum7);
                  break;
                case '近14天':
                  product.sell_point = product.realSaleNum14;
                  product.sell_point_str = String(product.realSaleNum14);
                  break;
                case '近30天':
                  product.sell_point = product.realSaleNum30;
                  product.sell_point_str = String(product.realSaleNum30);
                  break;
                default:
                  break;
              }
            }
            try {
              const customItem = itemList.find((item) => item.id == product.id);
              if (customItem && customItem.id != '0') {
                product.useCustomName = customItem.useCustomName;
                product.recommendType = customItem.recommendType;
                product.shoppersLabel = customItem.shoppersLabel;
                product.custom_unitPrice = customItem.shoppersLabelText;
                product.title = customItem.useCustomName ? customItem.name : product.title;
                product.recommend = customItem.recommendType === '自定义' ? (customItem.recommend) : (product.recommend);
                product.pocket = '超值好物';
                // 商品维度，商品图片、价格、跳转地址均要实时获取
                if (productType !== '商品id') {
                  product.image = customItem.productImageCustom || product.image;
                  product.price = customItem.productPrice || product.price;
                  product.url = customItem.productHref || product.url;
                }
              }
              if (product.rectImg) {
                rectImgs++;
              }
            } catch (error) {
              const customItem_beta = itemDataObj[product.id];
              if (customItem_beta) {
                product.useCustomName = customItem_beta.useCustomName;
                product.title = customItem_beta.name;
                product.recommend = customItem_beta.recommend;
              }
            }
          });
          if (cardBaseConfig.showRectImg === '是' && rectImgs == List.length) {
            showRectImg = true;
          }
          this.setState({
            visiable: true,
            list: List,
            showRectImg: showRectImg
          }, () => {
            this.setSalesVisiable();
            this.addEventListenerScroll();
          });
        }

        this.isLoading = false;
      }
    });
  }

  setSalesVisiable = () => {
    const { cardInfoConfig = {} } = this.props.config;
    if (cardInfoConfig.priceInfo === '销量' && this.gatherRef) {
      this.gatherRef.querySelectorAll('.goods-item').forEach((item, index) => {
        const goodsItemBottom = item.querySelector('.goods-item-bottom');
        const goodsItemPrice = item.querySelector('.goods-item-price');
        const priceInfoW = goodsItemBottom ? goodsItemBottom.offsetWidth : 0;
        const priceW = goodsItemPrice ? goodsItemPrice.clientWidth : 0;
        const sales = item.querySelector('.sales');
        if (sales) {
          const salesW = sales.clientWidth;
          if (salesW + priceW < priceInfoW) {
            sales.style.visibility = 'visible';
          }
        }
      })
    }
  }

  getDiscountRate = (price, original_price) => {
    let discountRate = price / original_price;
    if (discountRate > 1 || isNaN(discountRate) || original_price === 0) {
      discountRate = 1;
    }
    discountRate = discountRate * 10;
    discountRate = parseFloat(discountRate.toFixed(1));
    return discountRate;
  }

  handleItemClick = (item, index) => {
    const { baseConfig = {}, cardBaseConfig = {} } = this.props.config;
    const options = {
      title: baseConfig.title,
      type: cardBaseConfig.productStyle,
      sort: index,
      name: item.title
    };
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);
  }

  handleMoreClick = () => {
    const { baseConfig = {} } = this.props.config;
    const browserMoreHref = baseConfig.browserMoreHref;
    if (browserMoreHref) {
      const convertUrl = utils.convertHref(browserMoreHref);
      utils.jumpToUrl(this.props.routeParams, convertUrl, convertUrl, {}, -1, this.props, false);
    }
  }

  // 格式化单位价
  formatUnitPrice(price) {
    const match = price.match(/^([^\d]*)(\d+)(\.\d+)?(.*)$/);
  
    if (!match) return price;
  
    const [, symbol, integer, decimal = "", unit = ""] = match;
  
    return (
      <div>
        <span style={{ fontSize: px2rem('16px') }}>{integer}</span>
        <span style={{ fontSize: px2rem('10px') }}>{decimal}{unit}</span>
      </div>
    )
  }

  renderBenefitDom(item) {
    const { cardInfoConfig = {} } = this.props.config;
    let benefitDom = null;
    if (cardInfoConfig.benefit === '标签&推荐理由') {
      if (cardInfoConfig.priority === '优先展示标签') {
        if ((item.labels && item.labels.length > 0)) {
          benefitDom = this.renderLabels(item.labels);
        } else {
          benefitDom = <p className="goods-item-benefit">{item.recommend || item.pocket}</p>
        }
      } else {
        if (item.recommend) {
          benefitDom = <p className="goods-item-benefit">{item.recommend}</p>
        } else {
          if (item.labels && item.labels.length > 0) {
            benefitDom = this.renderLabels(item.labels);
          } else {
            benefitDom = <p className="goods-item-benefit">{item.pocket}</p>
          }
        }
      }
    } else if (cardInfoConfig.benefit === '单位价格') {
      if (cardInfoConfig.unitPriceReplacePrice && item.unit_price_text) {
        // 设置优先展示单位价且单位价存在时，此处展示总价
        benefitDom = <p className="goods-item-benefit" style={{ color: '#FF6000' }}>总价¥{item.price}</p>
      } else {
        benefitDom = <p className="goods-item-benefit">{item.unit_price_text}</p>
      }
    }

    return benefitDom;
  }

  // 单行商品滑动
  renderSingularRow() {
    const { baseConfig = {}, cardBaseConfig = {}, cardInfoConfig = {}, itemList = [] } = this.props.config;
    const { list = [] } = this.state;
    return (
      <div className="conatiner">
        <div
          ref={ele => {
            if (ele) {
              this.props.exp && this.props.exp(ele);
            }
          }}
          data-dot={JSON.stringify(utils.getExposureData(this.props, { title: baseConfig.title || '' }, {
            bizExtra: {
              model_block: '模块标题'
            }
          }))}
          className="module-title"
          onClick={() => this.handleMoreClick()}
        >
          <img src={utils.formatImgUrl(baseConfig.titleBgImage, this.props.webpSupport)} alt="" />
          <div className={baseConfig.browserMoreHref ? 'gradient has-btn' : 'gradient'} style={{background: (baseConfig.showGradientColor || baseConfig.showGradientColor === undefined) ? `linear-gradient(180deg, ${hexColorToRgba(baseConfig.gradientColor, 0)} 0%, ${hexColorToRgba(baseConfig.gradientColor, 1)} 41%, ${hexColorToRgba(baseConfig.gradientColor, 1)} 100%)` : 'transparent'}}>
            {
              (baseConfig.showTitle || baseConfig.showTitle === undefined) && <p className="title" style={{color: baseConfig.titleColor}}>{baseConfig.title.slice(0, 8)}</p>
            }
            {
              baseConfig.browserMoreHref && (
                <div
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                    bizExtra: {
                      model_block: '查看更多'
                    }
                  }))}
                  className="browser-more-btn"
                  style={{
                    color: baseConfig.titleColor,
                    borderColor: baseConfig.titleColor
                  }}
                >
                  查看更多
                  <svg t="1701673137576" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2359" width="12" height="12">
                    <path d="M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z" p-id="2360" fill={baseConfig.titleColor}></path>
                  </svg>
                </div>
              )
            }
          </div>
        </div>
        <div className="goods-body" ref={ref => this.goodsBodyRef = ref}>
          <div className={list.length > 20 && baseConfig.browserMoreHref ? "goods-scroll has-browser-more" : "goods-scroll"} ref={ref => this.goodsScrollRef = ref}>
            { this.renderCard(list.slice(0, 20)) } 
            {
              list.length > 20 && baseConfig.browserMoreHref && (
                <div
                  ref={ele => {
                    if (ele) {
                      this.props.exp && this.props.exp(ele);
                    }
                  }}
                  data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                    bizExtra: {
                      model_block: '查看更多'
                    }
                  }))}
                  className="browser-more"
                  onClick={() => this.handleMoreClick()}
                >
                  <p
                    className="btn"
                    style={{backgroundColor: cardBaseConfig.browserMoreBgColor, color: cardBaseConfig.browserMoreTxtColor}}
                  >
                    查看更多
                  </p>
                </div>
              )
            }
          </div>
          { this.renderCarouselBar() }
        </div>
      </div>
    )
  }

  // 双行商品滑动
  renderDuplicateRow() {
    const { baseConfig = {}, cardBaseConfig = {} } = this.props.config;
    let { list = [] } = this.state;
    const isEvenNum = list.length % 2;
    if (isEvenNum !== 0) {
      list.pop();
    }
    const middle = parseInt(list.length / 2);
    return (
      <Fragment>
        <div className="conatiner">
          <div className="goods-body" ref={ref => this.goodsBodyRef = ref}>
            <div className={list.length > 40 && baseConfig.browserMoreHref ? "goods-scroll has-browser-more" : "goods-scroll"} ref={ref => this.goodsScrollRef = ref}>
              <div
                ref={ele => {
                  if (ele) {
                    this.props.exp && this.props.exp(ele);
                  }
                }}
                data-dot={JSON.stringify(utils.getExposureData(this.props, { title: baseConfig.title || '' }, {
                  bizExtra: {
                    model_block: '模块标题'
                  }
                }))}
                className="module-title"
                onClick={() => this.handleMoreClick()}
              >
                <img src={utils.formatImgUrl(baseConfig.titleBgImage, this.props.webpSupport)} alt="" />
                <div className={baseConfig.browserMoreHref ? 'gradient has-btn' : 'gradient'} style={{background: (baseConfig.showGradientColor || baseConfig.showGradientColor === undefined) ? `linear-gradient(180deg, ${hexColorToRgba(baseConfig.gradientColor, 0)} 0%, ${hexColorToRgba(baseConfig.gradientColor, 1)} 41%, ${hexColorToRgba(baseConfig.gradientColor, 1)} 100%)` : 'transparent'}}>
                  {
                    (baseConfig.showTitle || baseConfig.showTitle === undefined) && <p className="title" style={{color: baseConfig.titleColor}}>{baseConfig.title.slice(0, 8)}</p>
                  }
                  {
                    baseConfig.browserMoreHref && (
                      <div
                        ref={ele => {
                          if (ele) {
                            this.props.exp && this.props.exp(ele);
                          }
                        }}
                        data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                          bizExtra: {
                            model_block: '查看更多'
                          }
                        }))}
                        className="browser-more-btn"
                        style={{
                          color: baseConfig.titleColor,
                          borderColor: baseConfig.titleColor
                        }}
                      >
                        查看更多
                        <svg t="1701673137576" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2359" width="12" height="12">
                          <path d="M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z" p-id="2360" fill={baseConfig.titleColor}></path>
                        </svg>
                      </div>
                    )
                  }
                </div>
              </div>
              <div className={list.length > 40 && baseConfig.browserMoreHref ? "scroll-wrap has-browser-more" : "scroll-wrap"}>
                <div className="scroll-item">
                  { this.renderCard(list.slice(0, middle)) }
                </div>
                <div className="scroll-item">
                  { this.renderCard(list.slice(middle, list.length), middle) }
                </div>
              </div>
              {
                list.length > 40 && baseConfig.browserMoreHref && (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, {}, {
                      bizExtra: {
                        model_block: '查看更多'
                      }
                    }))}
                    className="browser-more"
                    onClick={() => this.handleMoreClick()}
                  >
                    <p
                      className="btn"
                      style={{backgroundColor: cardBaseConfig.browserMoreBgColor, color: cardBaseConfig.browserMoreTxtColor}}
                    >
                      查看更多
                    </p>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        { this.renderCarouselBar() }
      </Fragment>
    )
  }

  // 渲染价格
  renderPrice(item) {
    const { baseConfig = {}, cardInfoConfig ={} } = this.props.config;
    const unit_price_text = item.unit_price_text.replace('¥', '');
    if (cardInfoConfig.benefit === '单位价格' && cardInfoConfig.unitPriceReplacePrice && item.unit_price_text) {
      // 优先展示单位价
      return (
        <div className="goods-item-price" style={{color: baseConfig.priceColor}}>
          <span className='rmb-icon'>¥</span>
          <p className={String(parseFloat(item.unit_price_text)).length > 5 ? 'long' : 'small'}>{this.formatUnitPrice(unit_price_text)}</p>
        </div>
      )
    } else {
      // 正常展示价格
      if (item.price >= 0 && (!cardInfoConfig.newUserPrice || cardInfoConfig.newUserPrice === '无')) {
        return (
          <div className="goods-item-price" style={{color: baseConfig.priceColor}}>
            <span className='rmb-icon'>¥</span>
            <p className={String(parseFloat(item.price)).length > 5 ? 'long' : 'small'}>{item.price && parseFloat(item.price)}</p>
          </div>
        )
      }
    }
  }

  renderCard(list = [], baseIndex = 0) {
    const { baseConfig = {}, cardBaseConfig = {}, cardInfoConfig ={} } = this.props.config;
    return (
      <Fragment>
        {
          list.map((item, index) => {
            // 折扣计算
            const discountRate = this.getDiscountRate(item.price, item.original_price);
            const benefitDom = this.renderBenefitDom(item);
            return (
              <div
                ref={ele => {
                  if (ele) {
                    this.props.exp && this.props.exp(ele);
                  }
                }}
                data-dot={JSON.stringify(utils.getExposureData(this.props, {
                  title: baseConfig.title,
                  type: cardBaseConfig.productStyle,
                  sort: baseIndex + index,
                  name: item.title
                }))}
                className={index === list.length - 1 ? 'goods-item last-one' : 'goods-item'}
                key={`goods-${baseIndex + index}`}
                onClick={() => this.handleItemClick(item, baseIndex + index)}
              >
                <div className="goods-item-img">
                  <LazyLoadImage
                    width={px2rem('96px')}
                    height={px2rem('96px')}
                    effect="opacity"
                    src={utils.formatImgUrl(item.image, this.props.webpSupport, 'card')}
                  />
                  {
                    cardBaseConfig.showCardMask !== '否' && <div className="mask"></div>
                  }
                </div>
                <div className="goods-item-info">
                  <p className="goods-item-title" style={{color: cardBaseConfig.productNameColor}}>
                    {item.title}
                  </p>
                  {benefitDom}
                </div>
                <div className="goods-item-bottom" style={{justifyContent: ['原价', '折扣'].indexOf(cardInfoConfig.priceInfo) >= 0 ? 'flex-start' : 'space-between'}}>
                  {
                    this.renderPrice(item)
                  }
                  {
                    cardInfoConfig.newUserPrice === '新人价' && item.new_user_price && (
                      <div className="goods-item-price" style={{color: baseConfig.priceColor}}>
                        <span className='rmb-icon'>¥</span>
                        <p className={String(parseFloat(item.new_user_price)).length > 5 ? 'long' : 'small'}>{item.new_user_price && parseFloat(item.new_user_price)}</p>
                      </div>
                    )
                  }
                  { cardInfoConfig.priceInfo === '原价' && <p className="origin-price" style={{color: baseConfig.priceInfoColor}}>¥{item.original_price}</p> }
                  { cardInfoConfig.priceInfo === '折扣' && discountRate != 10 && <p className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</p> }
                  { cardInfoConfig.priceInfo === '销量' && item.sell_point > 0 && <p className="sales" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str}人付款</p> }
                </div>
              </div>
            )
          })
        }
      </Fragment>
    )
  }

  render() {
    const { baseConfig = {}, cardBaseConfig = {}, cardInfoConfig = {} } = this.props.config;
    const className = `pipeline-productGather ${cardBaseConfig.slideType === '单行商品滑动' ? 'singular-row' : 'duplicate-row'} ${cardInfoConfig.benefit !== '无' ? 'has-benefit' : 'not-benefit'}`
    return (
      <div
        ref={ref => this.gatherRef = ref}
        id={this.props['customAttributes']['data-component-id']}
        className={className}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0
        }}
      >
        {
          cardBaseConfig.slideType === '单行商品滑动'
            ? this.renderSingularRow()
            : this.renderDuplicateRow()
        }
      </div>
    )
  }

  // 轮播条
  renderCarouselBar() {
    const { cardBaseConfig } = this.props.config;
    let carouselBgColor, progressColor;
    switch (cardBaseConfig.carouselBarColor) {
      case '白色':
        // carouselBgColor = 'rgba(255, 255, 255, 0.3)';
        progressColor = '#ff4338';
        break;
      case '黑色':
        // carouselBgColor = 'rgba(202, 202, 202, 0.3)';
        progressColor = '#ff4338';
        break;
      default:
        // carouselBgColor = 'rgba(255, 255, 255, 0.3)';
        progressColor = '#ff4338';
        break;
    }
    return (
      <div className="carousel-bar">
        <div className="carousel-bg" style={{backgroundColor: carouselBgColor}} ref={ref => this.carouselBgRef = ref}></div>
        <div className="carousel-progress" style={{backgroundColor: progressColor}} ref={ref => this.progressRef = ref}></div>
      </div>
    )
  }

  // 标签
  renderLabels(labels = []) {
    return (
      <div className="labels">
        {
          labels.map((item, index) => {
            let color = '', borderColor = '', backgroundColor = '';
            if (item.type === 'NEW_GOODS') {
              color = '#3E455E';
              borderColor = '#C8CEE4';
              backgroundColor = 'transparent';
            } else {
              color = '#FF4338';
              borderColor = '#FFB4B3';
              backgroundColor = 'transparent';
            }
            return (
              <p
                key={`label-${index}`}
                className={this.isAndroid ? 'android' : 'ios'}
                style={{
                  color,
                  borderColor,
                  backgroundColor
                }}
              >
                {item.text}
              </p>
            )
          })
        }
      </div>
    )
  }
}

PipelineProductGather.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineProductGather };
export default PipelineProductGather;



// WEBPACK FOOTER //
// ./components/pipeline-productGather/index.js